export default __webpack_public_path__ + "static/media/arrival-banner-1.87f15801.webp";